import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const tournamentLinesSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.TOURNAMENT_LINES_OPPONENT_SELECT}`,
        popover: {
            title: "Select Opponent",
            description:
                "Choose an opponent team from the dropdown to load the head-to-head line comparison. " +
                "All other sections on this page will populate once an opponent is selected.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_H2H_MATCH_SELECTOR}`,
        popover: {
            title: "Match Filter",
            description:
                "Click either team's card to open a match picker where you can select a specific subset of games. " +
                "By default all matches are included; narrow the selection to focus on recent form, home games, or any custom range.",
            side: "bottom",
            align: "center",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_H2H_LINES}`,
        popover: {
            title: "Line-by-Line Averages",
            description:
                "Each line (1–4) shows a pair of stat cards — one per team — with average KPI scores for " +
                "Defensive, Offensive, Team Play, Effort, Bonus, and Total across the selected matches. " +
                "A radar chart compares the two teams side-by-side. " +
                "Click any line header to expand it and see the individual player breakdown for both rosters.",
            side: "right",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_H2H_CHARTS}`,
        popover: {
            title: "Line Performance Over Time",
            description:
                "Two side-by-side line charts track how each line's total KPI evolved match by match throughout the tournament. " +
                "Toggle individual lines on or off to focus on the matchup that interests you most.",
            side: "top",
            align: "center",
        },
    },
];
